// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingOffers_body__VX9cx {
  display: flex;
  justify-content: space-between;
}
.LoadingOffers_body__VX9cx p {
  margin: 0;
}
.LoadingOffers_body__VX9cx Button {
  margin-top: 16px;
  width: 100%;
}

.LoadingOffers_options-subtitle__-zo7F {
  font-size: 14px;
  padding-top: 6px;
  margin-bottom: 15px !important;
  color: #808080;
}

.LoadingOffers_options__6s9E0 {
  width: 40%;
}

.LoadingOffers_option-detail__YH\\+Gl {
  width: 58%;
}

.LoadingOffers_sub-label__seNeu {
  height: 15px;
  width: 395px;
}

.LoadingOffers_input-radio__CHIh8 {
  vertical-align: text-bottom;
  cursor: pointer;
}

.LoadingOffers_input-tag__dXauh {
  height: 20px;
  width: 235px;
  display: inline-block;
  margin-right: 20px;
}

.LoadingOffers_offer-head__elPrd {
  margin-bottom: 8px;
  width: 430px;
}

.LoadingOffers_eta__pMHA2 {
  height: 20px;
  width: 150px;
  display: inline-block;
}

.LoadingOffers_first-card__3PZw4 {
  margin-bottom: 24px;
}

.LoadingOffers_product-wrapper__1euN0 {
  margin-bottom: 24px;
}

.LoadingOffers_product__ms-ss {
  min-width: 570px;
  width: 49.5vw;
}
.LoadingOffers_product__ms-ss .LoadingOffers_header__VD5NB {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 24px;
}
.LoadingOffers_product__ms-ss .LoadingOffers_header__VD5NB .LoadingOffers_item-title__hKy0G {
  height: 20px;
  width: 300px;
}
.LoadingOffers_product__ms-ss .LoadingOffers_header__VD5NB .LoadingOffers_item-price__OxTjo {
  height: 20px;
  width: 80px;
  margin-right: 23px;
}
.LoadingOffers_product__ms-ss .LoadingOffers_body__VX9cx {
  display: flex;
  justify-content: space-between;
}
.LoadingOffers_product__ms-ss .LoadingOffers_body__VX9cx .LoadingOffers_image__dyaOE {
  width: 140px;
  height: 140px;
}
.LoadingOffers_product__ms-ss .LoadingOffers_body__VX9cx .LoadingOffers_properties__PDLVL {
  display: flex;
  width: 55%;
}
.LoadingOffers_product__ms-ss .LoadingOffers_body__VX9cx .LoadingOffers_properties__PDLVL .LoadingOffers_image-product__1bCu\\+ {
  height: 100px;
  width: 100px;
  margin-right: 27px;
}
.LoadingOffers_product__ms-ss .LoadingOffers_body__VX9cx .LoadingOffers_properties__PDLVL .LoadingOffers_properties-title__3dvWw {
  height: 25px;
  width: 200px;
}
.LoadingOffers_product__ms-ss .LoadingOffers_body__VX9cx .LoadingOffers_properties__PDLVL .LoadingOffers_properties-text__3rpHe {
  height: 20px;
  width: 100px;
  margin: 3px 0px;
}
.LoadingOffers_product__ms-ss .LoadingOffers_body__VX9cx .LoadingOffers_options__6s9E0 {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: space-between;
}
.LoadingOffers_product__ms-ss .LoadingOffers_body__VX9cx .LoadingOffers_options__6s9E0 .LoadingOffers_quantity-wrapper__vVDQD {
  display: block;
}
.LoadingOffers_product__ms-ss .LoadingOffers_body__VX9cx .LoadingOffers_options__6s9E0 .LoadingOffers_quantity-wrapper__vVDQD .LoadingOffers_quantity-text__CiuCa {
  height: 20px;
  width: 50px;
  margin-bottom: 3px;
}
.LoadingOffers_product__ms-ss .LoadingOffers_body__VX9cx .LoadingOffers_options__6s9E0 .LoadingOffers_quantity-wrapper__vVDQD .LoadingOffers_unit-container__8MewU {
  display: flex;
  align-items: center;
  height: 20px;
  width: 150px;
}
.LoadingOffers_product__ms-ss .LoadingOffers_body__VX9cx .LoadingOffers_options__6s9E0 .LoadingOffers_buttons-wrapper__N\\+1lV {
  height: 20px;
  width: 80px;
  margin-left: auto;
}

.LoadingOffers_total-price__czqRb {
  height: 25px;
  width: 180px;
}

.LoadingOffers_sub-description__JmtC2 {
  height: 10px;
  width: 130px;
  margin-bottom: 12px !important;
}

.LoadingOffers_description__ltdFw {
  height: 15px;
  width: 680px;
  margin-bottom: 10px !important;
}

.LoadingOffers_green-text__-yd0N {
  height: 10px;
  width: 110px;
  margin-top: 3px !important;
  margin-bottom: 8px !important;
}

.LoadingOffers_loading-card__-cvCq {
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  padding: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
  width: 100%;
  float: right;
}

.LoadingOffers_data-wrapper__RZyc6 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3px;
}

.LoadingOffers_left-text__q40HZ {
  height: 20px;
  width: 70px;
}

.LoadingOffers_right-text__upmXa {
  height: 20px;
  width: 100px;
}

.LoadingOffers_total-wrapper__g6ZEc {
  height: 25px;
  width: 200px;
  display: flex;
  justify-content: space-between;
}

.LoadingOffers_right-wrapper__qiJwJ {
  float: right;
}

.LoadingOffers_loading__xApJL {
  background: linear-gradient(-45deg, #ffffff, rgb(219, 214, 214));
  background-size: 400% 400%;
  animation: LoadingOffers_gradient__UkzOn 4s ease infinite;
}

@keyframes LoadingOffers_gradient__UkzOn {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Offers/LoadingOffers/LoadingOffers.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,8BAAA;AAFF;AAGE;EACE,SAAA;AADJ;AAGE;EACE,gBAAA;EACA,WAAA;AADJ;;AAKA;EACE,eCfO;EDgBP,gBAAA;EACA,8BAAA;EACA,cAAA;AAFF;;AAKA;EACE,UAAA;AAFF;;AAKA;EACE,UAAA;AAFF;;AAKA;EACE,YAAA;EACA,YAAA;AAFF;;AAKA;EACE,2BAAA;EACA,eAAA;AAFF;;AAKA;EACE,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,YAAA;AAFF;;AAKA;EACE,YAAA;EACA,YAAA;EACA,qBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,aAAA;AAFF;AAGE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AADJ;AAEI;EACE,YAAA;EACA,YAAA;AAAN;AAEI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAAN;AAGE;EACE,aAAA;EACA,8BAAA;AADJ;AAEI;EACE,YAAA;EACA,aAAA;AAAN;AAEI;EACE,aAAA;EACA,UAAA;AAAN;AACM;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AACR;AACM;EACE,YAAA;EACA,YAAA;AACR;AACM;EACE,YAAA;EACA,YAAA;EACA,eAAA;AACR;AAEI;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,8BAAA;AAAN;AACM;EACE,cAAA;AACR;AAAQ;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAEV;AAAQ;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;AAEV;AACM;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AACR;;AAKA;EACE,YAAA;EACA,YAAA;AAFF;;AAKA;EACE,YAAA;EACA,YAAA;EACA,8BAAA;AAFF;;AAKA;EACE,YAAA;EACA,YAAA;EACA,8BAAA;AAFF;;AAKA;EACE,YAAA;EACA,YAAA;EACA,0BAAA;EACA,6BAAA;AAFF;;AAKA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;AAFF;;AAKA;EACE,YAAA;EACA,WAAA;AAFF;;AAKA;EACE,YAAA;EACA,YAAA;AAFF;;AAKA;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,gEAAA;EACA,0BAAA;EACA,yDAAA;AAFF;;AAKA;EACE;IACE,2BAAA;EAFF;EAIA;IACE,6BAAA;EAFF;EAIA;IACE,2BAAA;EAFF;AACF","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n\n.body {\n  display: flex;\n  justify-content: space-between;\n  p {\n    margin: 0;\n  }\n  Button {\n    margin-top: 16px;\n    width: 100%;\n  }\n}\n\n.options-subtitle {\n  font-size: typography.$body-m;\n  padding-top: 6px;\n  margin-bottom: 15px !important;\n  color: #808080;\n}\n\n.options {\n  width: 40%;\n}\n\n.option-detail {\n  width: 58%;\n}\n\n.sub-label {\n  height: 15px;\n  width: 395px;\n}\n\n.input-radio {\n  vertical-align: text-bottom;\n  cursor: pointer;\n}\n\n.input-tag {\n  height: 20px;\n  width: 235px;\n  display: inline-block;\n  margin-right: 20px;\n}\n\n.offer-head {\n  margin-bottom: 8px;\n  width: 430px;\n}\n\n.eta {\n  height: 20px;\n  width: 150px;\n  display: inline-block;\n}\n\n.first-card {\n  margin-bottom: 24px;\n}\n\n.product-wrapper {\n  margin-bottom: 24px;\n}\n\n.product {\n  min-width: 570px;\n  width: 49.5vw;\n  .header {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    margin-bottom: 24px;\n    .item-title {\n      height: 20px;\n      width: 300px;\n    }\n    .item-price {\n      height: 20px;\n      width: 80px;\n      margin-right: 23px;\n    }\n  }\n  .body {\n    display: flex;\n    justify-content: space-between;\n    .image {\n      width: 140px;\n      height: 140px;\n    }\n    .properties {\n      display: flex;\n      width: 55%;\n      .image-product {\n        height: 100px;\n        width: 100px;\n        margin-right: 27px;\n      }\n      .properties-title {\n        height: 25px;\n        width: 200px;\n      }\n      .properties-text {\n        height: 20px;\n        width: 100px;\n        margin: 3px 0px;\n      }\n    }\n    .options {\n      display: flex;\n      flex-wrap: wrap;\n      flex-direction: column;\n      justify-content: space-between;\n      .quantity-wrapper {\n        display: block;\n        .quantity-text {\n          height: 20px;\n          width: 50px;\n          margin-bottom: 3px;\n        }\n        .unit-container {\n          display: flex;\n          align-items: center;\n          height: 20px;\n          width: 150px;\n        }\n      }\n      .buttons-wrapper {\n        height: 20px;\n        width: 80px;\n        margin-left: auto;\n      }\n    }\n  }\n}\n\n.total-price {\n  height: 25px;\n  width: 180px;\n}\n\n.sub-description {\n  height: 10px;\n  width: 130px;\n  margin-bottom: 12px !important;\n}\n\n.description {\n  height: 15px;\n  width: 680px;\n  margin-bottom: 10px !important;\n}\n\n.green-text {\n  height: 10px;\n  width: 110px;\n  margin-top: 3px !important;\n  margin-bottom: 8px !important;\n}\n\n.loading-card {\n  border: 1px solid #e6e6e6;\n  border-radius: 10px;\n  padding: 15px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  width: 100%;\n  float: right;\n}\n\n.data-wrapper {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 3px;\n}\n\n.left-text {\n  height: 20px;\n  width: 70px;\n}\n\n.right-text {\n  height: 20px;\n  width: 100px;\n}\n\n.total-wrapper {\n  height: 25px;\n  width: 200px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.right-wrapper {\n  float: right;\n}\n\n.loading {\n  background: linear-gradient(-45deg, #ffffff, rgb(219, 214, 214));\n  background-size: 400% 400%;\n  animation: gradient 4s ease infinite;\n}\n\n@keyframes gradient {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `LoadingOffers_body__VX9cx`,
	"options-subtitle": `LoadingOffers_options-subtitle__-zo7F`,
	"options": `LoadingOffers_options__6s9E0`,
	"option-detail": `LoadingOffers_option-detail__YH+Gl`,
	"sub-label": `LoadingOffers_sub-label__seNeu`,
	"input-radio": `LoadingOffers_input-radio__CHIh8`,
	"input-tag": `LoadingOffers_input-tag__dXauh`,
	"offer-head": `LoadingOffers_offer-head__elPrd`,
	"eta": `LoadingOffers_eta__pMHA2`,
	"first-card": `LoadingOffers_first-card__3PZw4`,
	"product-wrapper": `LoadingOffers_product-wrapper__1euN0`,
	"product": `LoadingOffers_product__ms-ss`,
	"header": `LoadingOffers_header__VD5NB`,
	"item-title": `LoadingOffers_item-title__hKy0G`,
	"item-price": `LoadingOffers_item-price__OxTjo`,
	"image": `LoadingOffers_image__dyaOE`,
	"properties": `LoadingOffers_properties__PDLVL`,
	"image-product": `LoadingOffers_image-product__1bCu+`,
	"properties-title": `LoadingOffers_properties-title__3dvWw`,
	"properties-text": `LoadingOffers_properties-text__3rpHe`,
	"quantity-wrapper": `LoadingOffers_quantity-wrapper__vVDQD`,
	"quantity-text": `LoadingOffers_quantity-text__CiuCa`,
	"unit-container": `LoadingOffers_unit-container__8MewU`,
	"buttons-wrapper": `LoadingOffers_buttons-wrapper__N+1lV`,
	"total-price": `LoadingOffers_total-price__czqRb`,
	"sub-description": `LoadingOffers_sub-description__JmtC2`,
	"description": `LoadingOffers_description__ltdFw`,
	"green-text": `LoadingOffers_green-text__-yd0N`,
	"loading-card": `LoadingOffers_loading-card__-cvCq`,
	"data-wrapper": `LoadingOffers_data-wrapper__RZyc6`,
	"left-text": `LoadingOffers_left-text__q40HZ`,
	"right-text": `LoadingOffers_right-text__upmXa`,
	"total-wrapper": `LoadingOffers_total-wrapper__g6ZEc`,
	"right-wrapper": `LoadingOffers_right-wrapper__qiJwJ`,
	"loading": `LoadingOffers_loading__xApJL`,
	"gradient": `LoadingOffers_gradient__UkzOn`
};
export default ___CSS_LOADER_EXPORT___;
